import {
  BACKDROP_LIGHT,
  cherry,
  common,
  gray,
  paletteBase,
  purple,
} from 'constants/colors';

export interface MyPalette {
  dark: {
    main: string;
    100: string;
  };
  blue: {
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
  };
  cherry: {
    200: string;
    300: string;
    400: string;
    500: string;
  };
  gray: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    1000: string;
    1100: string;
    1200: string;
  };
  green: {
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
  };
  purple: {
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
  };
  primary2: {
    main: string;
    dark: string;
    gray: string;
    black: string;
  };
  background2: {
    step: string;
    paper: string;
  };
  backdrop: {
    main: string | undefined;
  };
  text: {
    disabled: string;
    secondary: string;
    primary: string;
  };
  red: {
    100: string;
    200: string;
    300: string;
  };
  font: {
    main: string;
    gray: string;
    dark: string;
  };
  alert: {
    gray: string;
    red: string;
    yellow: string;
    orange: string;
  };
  table: {
    main: string;
    textHeader: string;
    secondary: string;
    textHeaderSecondary: string;
    hover: string;
    row: string;
    header: string;
  };
}

export const palette = {
  ...paletteBase,
  dark: {
    main: '#525067',
    100: '#3F3D56',
    200: '#3F4247',
  },
  primary: {
    main: '#6D46DD',
    dark: '#25282B',
    gray: '#868686',
    black: '#000000',
  },
  primary2: {
    main: '#6D46DD',
    dark: '#25282B',
    gray: '#868686',
    black: '#000000',
  },
  secondary: {
    main: cherry[300],
    contrastText: gray[100],
    dark: cherry[400],
  },
  button: {
    white: '#fff',
  },
  background: {
    default: '#fff',
    paper: '#FFFFFF',
    step: '#E6E7EC',
  },
  background2: {
    paper: '#FFFFFF',
    step: '#E6E7EC',
  },
  text: {
    disabled: '#4D5378',
    secondary: '#757A96',
    primary: '#000000',
  },
  font: {
    main: '#000000',
    gray: '#757A96',
    dark: '#525067',
  },
  table: {
    main: purple[500],
    textHeader: gray[100],
    secondary: common.white,
    textHeaderSecondary: '#525067',
    hover: purple[300],
    row: common.white,
    header: gray[1200],
  },
  backdrop: {
    main: BACKDROP_LIGHT,
  },
};
